
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ExtraMoneyList } from "@/model/FinancialBookingModels";

import { isEmpty, toUpper } from "lodash";
import { LoadingPlanType } from "@/views/sales-management/SalesBookingOrderManagement.vue";

/**
 * 额外费用结算
 */
@Component({
  name: "ExtraTable",
})
export default class extends Vue {
  @Prop({ required: true }) private data: ExtraMoneyList[];
  @Prop({ required: false, default: false }) private useInvoiceMoney: boolean;
  @Prop({ required: false, default: false }) private idsList: [];
  private data_: ExtraMoneyList[] = [];
  private options: ExtraMoneyList[] = [];
  selection: ExtraMoneyList[] = [];

  @Watch("data", { immediate: true })
  private watchData() {
    this.data_ = [];
    this.data_.push(...this.data);
  }
  @Watch("idsList", { deep: true, immediate: true })
  private watchIdsList() {
    if (!this.idsList.length || !this.data.length) {
      return;
    }
    this.data.map((item) => {
      if (this.idsList.toString().indexOf(item.hqPackingListId) > -1) {
        this.toggleSelection([item]);
      }
    });
  }
  private toggleSelection(rows: ExtraMoneyList[]) {
    if (rows) {
      this.$nextTick(() => {
        rows.forEach((row) => {
          (
            this.$refs.multipleTable as Vue & { toggleRowSelection: Function }
          ).toggleRowSelection(row);
        });
      });
    } else {
      this.$nextTick(() => {
        (
          this.$refs.multipleTable as Vue & { clearSelection: Function }
        ).clearSelection();
      });
    }
  }

  private handleSelectionChange(rows: ExtraMoneyList[]) {
    this.selection = rows;
    let res = this.data_.filter(el => {
      return !rows.find(obj => {
        return el.hqPackingListId === obj.hqPackingListId;
      })
    })
    res.forEach(value => {
      value.settlementDeduct = "0";
      value.settlementFilling = "0";
    })
  }

  private checkSelectable(row: ExtraMoneyList) {
    return row.choice;
  }
}

export class LoadingPlanListTableRowData {
  id: string;
  code: string;
  createdDate: string;
  containerType: string;
  type: LoadingPlanType;
  category: string;
  loadingPlace: string;
  containerInfo: string;
  totalProductQuantity: number;
  totalAmount: string;
  totalVolume: string;
  select: boolean;

  isMatch(code?: string, category?: string, factoryName?: string): boolean {
    let match = true;
    if (!isEmpty(code)) {
      match = this.code.includes(toUpper(code));
    }
    if (!isEmpty(category)) {
      match = match && this.category === category;
    }
    if (!isEmpty(factoryName)) {
      match = match && this.loadingPlace.includes(factoryName);
    }
    return match;
  }
}
